var OpenClassConfig = (function () {
    function OpenClassConfig(apiService) {
        this.abilityClass = {
            "辅导": {
                abilityHostId: 72,
                learningPathMetaId: 1,
                practiceMetaId: 1
            },
            "打造高效团队": {
                abilityHostId: 70,
                learningPathMetaId: 2,
                practiceMetaId: 5
            },
            "授权": {
                abilityHostId: 73,
                learningPathMetaId: 11,
                practiceMetaId: 6
            },
            "计划与组织": {
                abilityHostId: 69,
                learningPathMetaId: 13,
                practiceMetaId: 7
            },
            "协作": {
                abilityHostId: 77,
                learningPathMetaId: 14,
                practiceMetaId: 8
            },
            "影响力": {
                abilityHostId: 75,
                learningPathMetaId: 15,
                practiceMetaId: 9
            },
            "影响力专业版": {
                abilityHostId: 78,
                learningPathMetaId: 30,
                practiceMetaId: 16
            },
            "决策": {
                abilityHostId: 68,
                learningPathMetaId: 16,
                practiceMetaId: 10
            },
            "驱动变革": {
                abilityHostId: 71,
                learningPathMetaId: 20,
                practiceMetaId: 11
            },
            "达至最佳绩效": {
                abilityHostId: 74,
                learningPathMetaId: 24,
                practiceMetaId: 13
            },
            "解决冲突": {
                abilityHostId: 76,
                learningPathMetaId: 28,
                practiceMetaId: 15
            }
        };
        this.apiService = apiService;
    }
    //通过methodId获取learningPathMetaName
    OpenClassConfig.prototype.getLearningPathMetaName = function (methodId) {
        var learningPathMetaName = "";
        switch (Number(methodId)) {
            case 721:
            case 722:
            case 723:
            case 724:
                learningPathMetaName = "辅导";
                break;
            case 701:
            case 702:
            case 703:
                learningPathMetaName = "打造高效团队";
                break;
            case 731:
            case 732:
            case 733:
                learningPathMetaName = "授权";
                break;
            case 691:
            case 692:
            case 693:
                learningPathMetaName = "计划与组织";
                break;
            case 771:
            case 772:
            case 773:
                learningPathMetaName = "协作";
                break;
            case 751:
            case 752:
            case 753:
                learningPathMetaName = "影响力";
                break;
            case 681:
            case 682:
            case 683:
                learningPathMetaName = "决策";
                break;
            case 711:
            case 712:
            case 713:
                learningPathMetaName = "驱动变革";
                break;
            case 741:
            case 742:
            case 743:
                learningPathMetaName = "达至最佳绩效";
                break;
            case 761:
            case 762:
            case 763:
                learningPathMetaName = "解决冲突";
                break;
        }
        return learningPathMetaName;
    };
    //返回能力learningPathMetaId和practiceMetaId
    OpenClassConfig.prototype.getAbilityIds = function (name) {
        return this.abilityClass[name];
    };
    //获取learningPath
    OpenClassConfig.prototype.getLearningPath = function (learningPathMetaId) {
        return this.apiService.getOrCreateLearningPath(learningPathMetaId);
    };
    //获取前测有没有完成
    OpenClassConfig.prototype.getPostSurvey = function (learningPathMetaId) {
        return this.apiService.ajax({
            "type": "get",
            "url": 'sr/survey/getSurvey/' + learningPathMetaId + '/1'
        });
    };
    return OpenClassConfig;
}());
export { OpenClassConfig };



// WEBPACK FOOTER //
// ./src/app/openClass-config/openClass-config.ts.pre-build-optimizer.js